import { usersApi } from '../api/usersApi'
import type { UserUpdateInput } from '../types/user'

export const updateUser = async (user: UserUpdateInput) => {
  try {
    const { data } = await usersApi.updateUser(user)
    return data
  } catch (error) {
    console.error(`Error updating users: `, error)
    throw error
  }
}
